var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesenvolvimento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "desenvolvimento",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desenvolvimento_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.6,37.2H45.4c-6.8,0-12.3,5.5-12.3,12.3v72c0,6.8,5.5,12.3,12.3,12.3h80.2c6.8,0,12.3-5.5,12.3-12.3v-72 C137.9,42.7,132.4,37.2,125.6,37.2z M45.4,45.4h80.2c2.3,0,4.1,1.8,4.1,4.1v12.3H41.3V49.5C41.3,47.2,43.1,45.4,45.4,45.4z  M125.6,125.6H45.4c-2.3,0-4.1-1.8-4.1-4.1V69.9h88.4v51.6C129.7,123.8,127.9,125.6,125.6,125.6z M47.4,53.6c0-2.3,1.8-4.1,4.1-4.1 s4.1,1.8,4.1,4.1c0,2.3-1.8,4.1-4.1,4.1S47.4,55.8,47.4,53.6z M61.8,53.6c0-2.3,1.8-4.1,4.1-4.1s4.1,1.8,4.1,4.1 c0,2.3-1.8,4.1-4.1,4.1C63.6,57.7,61.8,55.8,61.8,53.6z M86.2,77.7h8.5l-11.5,40.7h-8.5L86.2,77.7z M71.2,88.6l-11.3,9.6l11.3,9.6 l-5.3,6.2L47.3,98.2l18.6-15.8L71.2,88.6z M104.7,82.4l18.6,15.8L104.7,114l-5.3-6.2l11.3-9.6l-11.3-9.6L104.7,82.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesenvolvimento);
export default __webpack_public_path__ + "static/media/desenvolvimento.e13482ac03a6e1e33d04465b4a6eda5c.svg";
export { ForwardRef as ReactComponent };